/**
 * EST3 UX2 Wave 1 — nested Control Center navigation (locked IA).
 * Leaf keys map to existing shell panels where possible.
 */

export type Est3NavGroupKey =
  | 'overview'
  | 'scope'
  | 'direct'
  | 'project'
  | 'commercial'
  | 'documents'
  | 'governance';

export type Est3NavLeafKey =
  | 'health'
  | 'boq'
  | 'wbs'
  | 'cbs'
  | 'cost'
  | 'materials'
  | 'labour'
  | 'equipment'
  | 'subcontract'
  | 'explorer'
  | 'duration'
  | 'indirects'
  | 'time_related'
  | 'risks'
  | 'contingency'
  | 'escalation'
  | 'fx'
  | 'pricing_strategy'
  | 'client_pricing'
  | 'profitability'
  | 'sensitivity'
  | 'bid_reconciliation'
  | 'documents'
  | 'readiness'
  | 'approval'
  | 'revisions'
  | 'submission'
  | 'diagnostics'
  | 'budget_handoff';

export interface Est3NavLeaf {
  key: Est3NavLeafKey;
  label: string;
}

export interface Est3NavGroup {
  key: Est3NavGroupKey;
  label: string;
  leaves: Est3NavLeaf[];
}

export const EST3_CONTROL_CENTER_NAV: Est3NavGroup[] = [
  {
    key: 'overview',
    label: 'Overview',
    leaves: [{ key: 'health', label: 'Health & Attention' }],
  },
  {
    key: 'scope',
    label: 'Scope & BOQ',
    leaves: [
      { key: 'boq', label: 'Client BOQ' },
      { key: 'wbs', label: 'WBS' },
      { key: 'cbs', label: 'CBS' },
    ],
  },
  {
    key: 'direct',
    label: 'Direct Cost',
    leaves: [
      { key: 'cost', label: 'Summary' },
      { key: 'materials', label: 'Materials' },
      { key: 'labour', label: 'Labour & Crews' },
      { key: 'equipment', label: 'Equipment' },
      { key: 'subcontract', label: 'Subcontract' },
      { key: 'explorer', label: 'Cost Explorer' },
    ],
  },
  {
    key: 'project',
    label: 'Project Cost',
    leaves: [
      { key: 'duration', label: 'Duration' },
      { key: 'indirects', label: 'Indirects' },
      { key: 'time_related', label: 'Time-related' },
      { key: 'risks', label: 'Risk' },
      { key: 'contingency', label: 'Contingency' },
      { key: 'escalation', label: 'Escalation' },
      { key: 'fx', label: 'FX' },
    ],
  },
  {
    key: 'commercial',
    label: 'Commercial',
    leaves: [
      { key: 'pricing_strategy', label: 'Pricing Strategy' },
      { key: 'client_pricing', label: 'Client Pricing' },
      { key: 'profitability', label: 'Profitability' },
      { key: 'sensitivity', label: 'Sensitivity' },
      { key: 'bid_reconciliation', label: 'Bid Reconciliation' },
    ],
  },
  {
    key: 'documents',
    label: 'Documents',
    leaves: [{ key: 'documents', label: 'Evidence' }],
  },
  {
    key: 'governance',
    label: 'Governance',
    leaves: [
      { key: 'readiness', label: 'Readiness' },
      { key: 'approval', label: 'Approval' },
      { key: 'revisions', label: 'Revisions' },
      { key: 'submission', label: 'Submission Basis' },
      { key: 'diagnostics', label: 'Diagnostics' },
      { key: 'budget_handoff', label: 'Budget Handoff' },
    ],
  },
];

export function findGroupForLeaf(leaf: Est3NavLeafKey): Est3NavGroup | undefined {
  return EST3_CONTROL_CENTER_NAV.find((g) => g.leaves.some((l) => l.key === leaf));
}

export const EST3_DEFAULT_LEAF: Est3NavLeafKey = 'boq';
